export default "__VITE_ASSET__DAcxnJPA__"